/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_To_GoogleInputs */

const cs_sync_to_google = /** @type {(inputs: Sync_To_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat s Google Kalendářem`)
};

const en_sync_to_google = /** @type {(inputs: Sync_To_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to Google Calendar`)
};

/**
* | output |
* | --- |
* | "Sync to Google Calendar" |
*
* @param {Sync_To_GoogleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sync_to_google = /** @type {((inputs?: Sync_To_GoogleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_To_GoogleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sync_to_google(inputs)
	return cs_sync_to_google(inputs)
});